import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';
import { aboutInfo } from '@/mocks/about';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-300">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                爱液视频
              </span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-400">
              正版高清视频平台，海量优质内容，极速播放体验，多终端同步观看。让每一位用户都能享受正版高清的观影乐趣。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-500 text-secondary-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-500 text-secondary-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-500 text-secondary-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-background-50 font-semibold mb-4 text-sm">视频分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 font-semibold mb-4 text-sm">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/article/3" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">会员指南</Link></li>
              <li><Link to="/article/1" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">观影推荐</Link></li>
              <li><Link to="/article/5" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">4K指南</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 font-semibold mb-4 text-sm">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-secondary-400">
                <i className="ri-map-pin-line mt-0.5 text-secondary-500"></i>
                <span>{aboutInfo.contact.address}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-secondary-400">
                <i className="ri-phone-line text-secondary-500"></i>
                <span>{aboutInfo.contact.phone}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-secondary-400">
                <i className="ri-mail-line text-secondary-500"></i>
                <span>{aboutInfo.contact.email}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-500">
            &copy; {new Date().getFullYear()} 爱液视频 版权所有 | 京ICP备xxxxxxxx号 | 京公网安备xxxxxxxxxx号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-secondary-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-secondary-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-secondary-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}